import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import axios from 'axios';

export const deleteSavedView = async (id: string): Promise<{ id: string }> => {
  const networkPayload = await getRequestAuthPayload({ method: 'delete', url: `saved-views/${id}` });
  const response = await axios(networkPayload);
  return response.data;
};
